
export const gs25Routes = [
    {
        path: "/gs25list",
        name: "gs25list",
        component: () => import("@/views/gs25list/Gs25List.vue"),
        //component: () => import("@/views/brand/gsrbr0106.vue"),
        meta: { 
            hideLayout: true 
        }        
    }
];